import {NoteDialogNoteHeader as Header} from "./NoteDialogNoteHeader";
import {NoteDialogNoteContent as Content} from "./NoteDialogNoteContent";
import {NoteDialogNoteFooter as Footer} from "./NoteDialogNoteFooter";
import {NoteDialogNoteOptions as Options} from "./NoteDialogOptions/NoteDialogNoteOptions";

export const NoteDialogNoteComponents = {
  Header,
  Content,
  Options,
  Footer,
};
